<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t('performancereport') }}</div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getPerformanceReportFromDate"
                  v-on:click="onPerformanceReportDateHandler({event: null, name: 'fromDate'})"
                >✖</button>
                <Datepicker :monday-first="true"
                  @selected="onPerformanceReportDateHandler({event: $event, name: 'fromDate'})"
                  ref="programaticOpen"
                  :value="getPerformanceReportFromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getPerformanceReportFromDate ? 'active': ''">
                  {{ $t('show') }}
                  {{ $t('fromdate') }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getPerformanceReportToDate"
                  v-on:click="onPerformanceReportDateHandler({event: null, name: 'toDate'})"
                >✖</button>
                <Datepicker :monday-first="true"
                  @selected="onPerformanceReportDateHandler({event: $event, name: 'toDate'})"
                  ref="programaticOpen"
                  :value="getPerformanceReportToDate"
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="getPerformanceReportToDate ? 'active': ''"
                >{{ $t('show') }} {{ $t('todate') }}</label>
              </div>
            </div>
          </div>

          <div
            v-if="!getPerformanceReportsIsCinema"
            class="col-lg-6 col-xl-3 align-self-center mb-3"
          >
            <div class="dropdown-curve-container mr-2">
              <label :class="getPerformanceReportSelectedCinema.length > 0 ? 'shift-up' : ''">
                {{ $t('select') }}
                {{ $tc('cinema', 1) }}
              </label>
              <b-dropdown
                :text="getPerformanceReportSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getCinemasList"
                  :key="dropdownIndex"
                  @click="onPerformanceReportDropdownHandler({ event: $event, name:'Cinema',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click.prevent="fetchPerformanceReportList">
              {{ $t('fetch') }}
              {{ $t('report') }}
            </button>
          </div>
        </div>
      </div>
      <div>
        <!-- <b-dropdown id="listview" variant="outline-blue-lg">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
            >{{list.name}}</b-dropdown-item>
        </b-dropdown>-->
      </div>
<div class="table-scroll">
      <table
        v-if="getPerformanceReportList.length === 0"
        class="performance-report-table"
        border="1"
      >
        <thead>
          <tr>
            <td colspan="2"></td>
            <td colspan="3">{{ $t('audience') }}</td>
            <td colspan="4">{{ $t('revenue') }}</td>
            <td colspan="2">ATP</td>
          </tr>
          <tr>
            <td>{{ $t('film') }}</td>
            <td>{{ $t('noof') }} {{ $t('show') }}</td>
            <td>{{ $t('admits') }}</td>
            <td>{{ $tc('screen', 1) }} {{ $t('capacity') }}</td>
            <td>{{ $t('occupancy') }} %</td>
            <td>BOR</td>
            <td>{{ $t('tax') }}</td>
            <td>{{ $t('service') }} {{ $t('charge') }}</td>
            <td>Nett BOR</td>
            <td>BOR ATP</td>
            <td>{{ $t('net') }} ATP</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="11">
              <div class="h6 my-3 text-center">{{ $t('NoRecords') }}</div>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
<div class="table-scroll">
      <table v-if="getPerformanceReportList.length > 0" class="performance-report-table" border="1">
        <thead>
          <tr>
            <td colspan="2"></td>
            <td colspan="3">{{ $tc('audience') }}</td>
            <td :colspan="2+getPerformanceReportChargeList.length">{{ $t('revenue') }}</td>
            <td colspan="2">ATP</td>
          </tr>
          <tr>
            <td>{{ $t('film') }}</td>
            <td>{{ $t('noof') }} {{ $t('show') }}</td>
            <td>{{ $t('admits') }}</td>
            <td>{{ $tc('screen', 1) }} {{ $t('capacity') }}</td>
            <td>{{ $t('occupancy') }} %</td>
            <td>BOR</td>
            <td
              v-for="(Charge, ChargeIndex) in getPerformanceReportChargeList"
              :key="ChargeIndex+Charge.ChargeName"
            >
              <span>{{ Charge.ct_name }}</span>
            </td>
            <!-- <td>Tax</td>
            <td>Service Charge</td>-->
            <td>Nett BOR</td>
            <td>BOR ATP</td>
            <td>{{ $t('net') }} ATP</td>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(PerformanceReportList ,PerformanceReportListIndex) in getPerformanceReportList"
            :key="PerformanceReportListIndex"
          >
            <td>
              <div>{{ PerformanceReportList.movie_name }}</div>
              <div
                v-for="(Screen, ScreenIndex) in PerformanceReportList.Screens"
                :key="ScreenIndex+Screen.screen_name"
              >{{ Screen.screen_name }}</div>
              <!-- <div>Screen 2</div>
              <div>Screen 3</div>-->
            </td>
            <td>
              <div>&nbsp;</div>
              <div
                v-for="(Screen, ScreenIndex) in PerformanceReportList.Screens"
                :key="ScreenIndex+Screen.no_of_show"
              >{{ Screen.no_of_show }}</div>
              <!-- <div>8</div>
              <div>12</div>-->
            </td>
            <td>
              <div>&nbsp;</div>

              <div
                v-for="(Screen, ScreenIndex) in PerformanceReportList.Screens"
                :key="ScreenIndex+Screen.no_of_show+Screen.screen_name"
              >{{ Screen.Shows.length }}</div>
            </td>
            <td>
              <div>&nbsp;</div>
              <div
                v-for="(Screen, ScreenIndex) in PerformanceReportList.Screens"
                :key="ScreenIndex+Screen.screen_count+Screen.screen_name"
              >{{ Screen.screen_count }}</div>
            </td>
            <td>
              <div>&nbsp;</div>
              <div
                v-for="(Screen, ScreenIndex) in PerformanceReportList.Screens"
                :key="ScreenIndex+Screen.screen_count+Screen.screen_name+'Shows'"
              >{{ (parseFloat(Screen.Shows.length) / (parseFloat(Screen.screen_count) * parseFloat(Screen.no_of_show)) * 100).toFixed(this.MIN_FRACTION_DIGITS) }}</div>
            </td>
            <td>
              <div>&nbsp;</div>
              <div
                v-for="(Screen, ScreenIndex) in PerformanceReportList.Screens"
                :key="ScreenIndex+Screen.screen_count+Screen.screen_name+'GrossAmount'"
              >{{ Screen.Shows.reduce((accumulator, { t_gross_amount }) => accumulator + parseFloat(t_gross_amount),0).toFixed(this.MIN_FRACTION_DIGITS) }}</div>
            </td>

            <td
              v-for="(ChargeItem, ChargeIndex) in getPerformanceReportChargeList"
              :key="ChargeIndex+ChargeItem.ChargeName+ChargeItem.ct_name"
            >
              <div>&nbsp;</div>
              <div
                v-for="(Screen, ScreenIndex) in PerformanceReportList.Screens"
                :key="ScreenIndex+Screen.screen_count+Screen.screen_name+'Charges'"
              >{{ ChargeItem['ChargeName'] && Screen[ChargeItem.ChargeName] ? Screen[ChargeItem.ChargeName].toFixed(this.MIN_FRACTION_DIGITS) : '-' }}</div>
            </td>

            <!-- <td>0</td>
            <td>0.00</td>-->
            <td>
              <div>&nbsp;</div>
              <div
                v-for="(Screen, ScreenIndex) in PerformanceReportList.Screens"
                :key="ScreenIndex+Screen.screen_count+Screen.screen_name+'NetAmount'"
              >{{ Screen.Shows.reduce((accumulator, { t_net_amount }) => accumulator + parseFloat(t_net_amount),0).toFixed(this.MIN_FRACTION_DIGITS) }}</div>
            </td>
            <td>
              <div>&nbsp;</div>
              <div
                v-for="(Screen, ScreenIndex) in PerformanceReportList.Screens"
                :key="ScreenIndex+Screen.screen_count+Screen.screen_name+'GrossAmountPercent'"
              >{{ Screen.Shows && Screen.Shows.length > 0 ? (Screen.Shows.reduce((accumulator, { t_gross_amount }) => accumulator + parseFloat(t_gross_amount),0) / Screen.Shows.length).toFixed(this.MIN_FRACTION_DIGITS) : '-' }}</div>
            </td>
            <td>
              <div>&nbsp;</div>
              <div
                v-for="(Screen, ScreenIndex) in PerformanceReportList.Screens"
                :key="ScreenIndex+Screen.screen_count+Screen.screen_name+'NetAmountPercent'"
              >{{ Screen.Shows && Screen.Shows.length > 0 ? (Screen.Shows.reduce((accumulator, { t_net_amount }) => accumulator + parseFloat(t_net_amount),0) / Screen.Shows.length).toFixed(this.MIN_FRACTION_DIGITS) : '-' }}</div>
            </td>
          </tr>
          <!-- <tr>
            <td></td>
            <td>
              <strong>24</strong>
            </td>
            <td>
              <strong>81</strong>
            </td>
            <td>
              <strong>2,1488</strong>
            </td>
            <td></td>
            <td>
              <strong>4,578</strong>
            </td>
            <td>
              <strong>218</strong>
            </td>
            <td>
              <strong>0.00</strong>
            </td>
            <td>
              <strong>4,360</strong>
            </td>
            <td>
              <strong>56.0</strong>
            </td>
            <td>
              <strong>53.3</strong>
            </td>
          </tr>-->
        </tbody>
      </table>
      </div>

      <div
        v-if="getPerformanceExcelFileName"
        class="d-flex justify-content-end mt-5 align-items-center"
      >
        <div>Download as:</div>
        <button class="btn-transparent ml-3" title="Download as PDF">
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </button>

        <a
          :href="BASE_URL+getPerformanceExcelFileName"
          target="_blank"
          title="Download as Excel"
          download
        >
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
      </div>
    </div>

    <div class="white-wrapper">
      <h5> {{ $tc("concessionSaleAnalysis") }}</h5>
      <table class="concession-analysis-table">
        <thead>
          <tr>
            <th colspan="1" style="width:20%">{{ $tc("item") }}</th>
            <th colspan="4">{{ $tc("units") }}</th>
            <th colspan="4">{{ $tc("value") }}</th>
          </tr>

          <tr>
            <th></th>
            <th>{{ $tc("qty") }} {{ $tc("sold") }}</th>
            <th>Net Price</th>
            <th>Std Profit</th>
            <th>Std Profit %</th>
            <th>Net Sale</th>
            <th>Sale Mix</th>
            <th>Net Profit</th>
            <th>Profit Mix</th>
          </tr>
        </thead>
        <tbody class="border-bottom border-dark">
          <!-- CREATE THIS TR ONLY FIRST TIME -->
          <tr>
            <td>
              <strong>F&B</strong>
            </td>
            <td colspan="11"></td>
          </tr>
        </tbody>

        <tbody
          class="border-bottom border-dark"
          v-for="(PerformanceConcessionReports, PerformanceConcessionReportsIndex) in getPerformanceConcessionReportsList"
          :key="PerformanceConcessionReportsIndex"
        >
          <tr
            v-for="(SingleItem, SingleIndex) in PerformanceConcessionReports.FoodCategory"
            :key="SingleIndex"
          >
            <td>
              <p v-if="SingleIndex ===0">{{ SingleItem.fc_category }}</p>
              {{ SingleItem.item_name }}
            </td>
            <td>
              <p v-if="SingleIndex ===0">&nbsp;</p>
              {{ SingleItem.fst_quantity }}
            </td>
            <td>{{ SingleItem['net_price'] ? SingleItem.net_price.toFixed(this.MIN_FRACTION_DIGITS):"" }}</td>
            <td>{{ SingleItem['std_profit'] ? SingleItem.std_profit.toFixed(this.MIN_FRACTION_DIGITS): "" }}</td>
            <td>{{ SingleItem['std_profit'] && SingleItem['net_price'] ? ((SingleItem.std_profit / SingleItem.net_price) * 100).toFixed(this.MIN_FRACTION_DIGITS) : '' }}</td>

            <td>{{ SingleItem['net_sales'] ? SingleItem.net_sales.toFixed(this.MIN_FRACTION_DIGITS) : "" }}</td>
            <td>{{ SingleItem['net_sales'] && SingleItem['total_net_sales'] ? ((SingleItem.net_sales / SingleItem.total_net_sales) * 100).toFixed(this.MIN_FRACTION_DIGITS): "" }}</td>
            <td>{{ SingleItem['net_profit'] ? SingleItem.net_profit.toFixed(this.MIN_FRACTION_DIGITS) : "" }}</td>
            <td>{{ SingleItem['net_profit'] && SingleItem['total_std_profit'] ? ((SingleItem.net_profit/ SingleItem.total_std_profit) * 100).toFixed(this.MIN_FRACTION_DIGITS): "" }}</td>
          </tr>
        </tbody>
        <tbody class="border-bottom border-dark">
          <tr>
            <td>
              <strong>F&amp;B</strong>
            </td>

            <td>
              <strong>{{ getPerformanceRecordsTotal.qtySold }}</strong>
            </td>
            <td>
              <strong>{{ getPerformanceRecordsTotal.netPrice.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
            </td>
            <td>
              <strong>{{ getPerformanceRecordsTotal.stdProfit.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
            </td>
            <td>
              <strong>{{ getPerformanceRecordsTotal.stdProfitPercentage.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
            </td>
            <td>
              <strong>{{ getPerformanceRecordsTotal.netSale.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
            </td>
            <td>
              <strong>{{ getPerformanceRecordsTotal.saleMix.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
            </td>
            <td>
              <strong>{{ getPerformanceRecordsTotal.netProfit.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
            </td>
            <td>
              <strong>{{ getPerformanceRecordsTotal.profitMix.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { BASEURL } from "@/config/index";

export default {
  data() {
    return {
      BASEURL
    };
  },
  computed: {
    ...mapGetters([
      // Flags
      "getPerformanceReportsIsCinema",
      // End
      // Get Only
      "getCinemasList",
      //
      "getPerformanceReportChargeList",
      "getPerformanceReportList",

      "getPerformanceConcessionReportsList",
      "getPerformanceRecordsTotal",

      "getPerformanceReportToDate",
      "getPerformanceReportFromDate",
      "getPerformanceReportSelectedCinema",

      // EXCEL
      "getPerformanceExcelFileName"
    ])
  },
  beforeMount() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.onPerformanceReportFlagHandler({
      event: null,
      name: "isCinema",
      value: cinemaId
    });
    this.onPerformanceReportFlagHandler({
      event: null,
      name: "isCountry",
      value: this.secureStore.get("BRGLOPCO") || null
    });
    this.fetchCinemasList();
  },
  mounted() {},
  methods: {
    ...mapActions([
      "fetchPerformanceReportList",
      "onPerformanceReportDateHandler",
      "fetchCinemasList",
      "onPerformanceReportDropdownHandler",
      "onPerformanceReportFlagHandler",
      "onResetPerformanceReportStoreState"
    ])
  },
  beforeDestroy: async function() {
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getPerformanceExcelFileName
    });
    await this.onResetPerformanceReportStoreState();
  }
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/performanceReport.vue